export default __webpack_public_path__ + "static/media/logo.29356b39.svg";